import {readLanguageFromPath} from '../../../config/languages';

/**
 * window.open and any other absolute link bypasses the router, so the language
 * prefix that basename would have added has to be spelled out here.
 */
export const absoluteAppUrl = (path: string): string => {
    const {prefix} = readLanguageFromPath(window.location.pathname);
    return `${window.location.origin}${prefix}${path}`;
};
